<template>
	<div class="home">
		<header-view></header-view>
		<div class="content">
			<div class="content-top">Digital<br>Flower Art</div>
			<div class="content-middle">Make Someone's Day Bloom.</div>
			<div class="content-bottom" @click="toAbout">Create &amp; Share <span>with Flority</span></div>
		</div>
		<footer-view></footer-view>
	</div>
</template>

<script>
	// import * as api from '@/api'
	export default {
		data() {
			return {

			}
		},
		methods: {
			toAbout() {
				this.$router.push({
					path: '/about'
				})
			}
		},
		mounted() {

		},
		beforeDestroy() {}
	}
</script>
<style lang="less" scoped>
	.home {
		background: #F7F7F7;
		padding-top: 87px;

		.content {
			padding: 4.75rem 2.208333rem 0;
			color: #1A1C2E;
			height: 100vh;
			background: url(../assets/img/bg2.png) no-repeat;
			background-size: cover;

			.content-top {
				width: 19.5rem;
				font-family: 'C-B', sans-serif;
				font-size: 3rem;
				font-weight: 700;
				line-height: 1.1;
				color: #1A1C2E;
			}

			.content-middle {
				width: 26.5rem;
				margin-top: 0.8rem;
				font-family: 'C-R', sans-serif;
				font-size: 1.5rem;
				line-height: 1.3;
				color: #1A1C2E;
			}

			.content-bottom {
				background: #333333;
				border-radius: 0.666667rem;
				display: inline-block;
				color: #FDFDFD;
				font-size: 1.083333rem;
				padding: 0.75rem 1.25rem;
				margin-top: 3.5rem;
				cursor: pointer;

				span {
					font-weight: 600;
				}
			}
		}


	}

	@media (min-width:960px) {
		// .top{
		// 	width: 1200px !important;
		// 	margin: 0 auto;
		// }
	}
</style>